$(function(){
    /**
    * 画像の保存防止
    */

    document.addEventListener('contextmenu', (e) => {
        if (e.target.tagName === 'IMG') {
            e.preventDefault();
        }
    });
    document.addEventListener('dragstart', (e) => {
        if (e.target.tagName === 'IMG' || e.target.tagName === 'A') {
            e.preventDefault();
        }
    });

    //スムーズスクロール
  $('a[href^="#"]').on("click", event =>{
		const speed = 400; // ミリ秒
		const href= $(event.currentTarget).attr("href");
		const target = $(href == "#" || href == "" ? 'html' : href);
		const position = target.offset().top;
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

  //パスワード表示・非表示
  $flg = true
  $(".show_pw").on("click", function(){
    if($flg){
      $(this).prev("input").attr('type', 'text')
      //$(this).html("パスワードを隠す")
      $flg = false
    }else{
       $(this).prev("input").attr('type', 'password')
       //$(this).html("パスワードを表示する")
       $flg = true
    }
  })



    const $innerHeight = $(".agreement_sidebar_inner").height()
    //$(".agreement_sidebar").css("height", $innerHeight)

    if($(".agreement_sidebar_inner").length){
      var $start_top = $(".agreement_sidebar_inner").offset().top

      var $sidebar_h = $(".agreement_sidebar").height()
      var $sidebar_inner_h = $(".agreement_sidebar_inner").height()

      var $end_top = ($start_top + $sidebar_h) - $sidebar_inner_h

      $(window).on('scroll load', function(){
          $scroll = $(window).scrollTop()
          $scroll = $scroll + 80

          if ($start_top <= $scroll && $end_top >= $scroll){
              $(".agreement_sidebar_inner").addClass("fixed_slide")
              $(".agreement_sidebar_inner").removeClass("fixed_slide_end")
          }else if($start_top >= $scroll){
              $(".agreement_sidebar_inner").removeClass("fixed_slide")
          }else if($start_top <= $scroll && $end_top <= $scroll){
              $(".agreement_sidebar_inner").removeClass("fixed_slide")
              $(".agreement_sidebar_inner").addClass("fixed_slide_end")
          }
      })
    }

  //Q&A
  $(".faq_q").on("click", function(){

    if($(window).width() <= 840){
      if(!$(this).next("dd").is(':visible')){
        $(this).addClass("dt_open").next("dd").stop().slideDown()
      }else{
        $(this).removeClass("dt_open").next("dd").stop().slideUp()
      }
    }
  })

    var currentWidth = window.innerWidth;
    $(window).on('load resize', function(){
        if (currentWidth == window.innerWidth) {
            // ウインドウ横幅が変わっていないため処理をキャンセル。
            return;
        }
        if($(window).width() <= 840){

            if (currentWidth == window.innerWidth) {
        // ウインドウ横幅が変わっていないため処理をキャンセル。
        return;
    }

            $('.faq_a').hide()
            $('.faq_q').removeClass("dt_open")

        }else{

            $('.faq_a').show()
            $('.faq_q').removeClass("dt_open")

        }
    })


  //Goodsタイトルを省略
  $(".goods_item_text h3").each(function(){
    if ($(this).text().length > 24) {
      $(this).text($(this).text().substr(0, 23)).append('…')
    }
  })

  //マガジンタイトルを省略
  $(".magazine_item_text h3").each(function(){
    if ($(this).text().length > 41) {
      $(this).text($(this).text().substr(0, 40)).append('…')
    }
  })


  //catalog
  $(".catalog_sort_btn").on("click", function(){
    if($(window).width() <= 840){
      if(!$(this).next("dd").is(':visible')){
        $(this).addClass("dt_open").next("dd").stop().slideDown()
      }else{
        $(this).removeClass("dt_open").next("dd").stop().slideUp()
      }
    }
  })

  $(window).on('load resize', function(){

    if($(window).width() <= 840){

        if (currentWidth == window.innerWidth) {
            // ウインドウ横幅が変わっていないため処理をキャンセル。
            return;
        }

      $(".catalog_sort_btn").next("dd").hide()
      $(".catalog_sort_btn").removeClass("dt_open")

    }else{

      $(".catalog_sort_btn").next("dd").show()
      $(".catalog_sort_btn").removeClass("dt_open")

    }
  })

  //detailsの商品説明
  //説明文が200px以上であれば折りたたみ
  const $of200_h = $(".of200").height()

  if($of200_h > 200){
    $(".of200").addClass("h200")
    $(".of_btn").show()
  }

  $(".round_btn").on("click", function(){
    $(".of200").removeClass("h200")
    $(this).parent().hide()
  })


  //カート画面のエラークローズボタン
  $(".settlement_error li span").on("click", function(){
    $(this).parent().fadeOut()
  })

  //フォローボタン
  $(".follow_btn").on("click", function(){
    if($(this).hasClass("following")){
      $(this).removeClass("following").val("FOLLOW")
      return false
    }else{
      $(this).addClass("following").val("FOLLOWING")
      return false
    }
  })
  
  //indexフォローボタン
  $(".btn_follow").on("click", function(){
    if($(this).hasClass("following")){
      $(this).removeClass("following").text("FOLLOW")
      return false
    }else{
      $(this).addClass("following").text("FOLLOWING")
      return false
    }
  })

/*
  //ギャラリー・ストア名を50文字で省略
  var cutFigure = '50' // カットする文字数
  var afterTxt = '...' // 文字カット後に表示するテキスト

  $('.gallery_item_info h3').each(function(){
    var textLength = $(this).text().length
    var textTrim = $(this).text().substr(0,(cutFigure))

    if(cutFigure < textLength) {
        $(this).html(textTrim + afterTxt).css({visibility:'visible'})
    } else if(cutFigure >= textLength) {
        $(this).css({visibility:'visible'})
    }
  })
*/


  //お問い合わせ
  $(".contact_select").on("change", function(){
    const $codata  = $(".contact_select option:selected").data("co");

    switch($codata){
      case "co-itemnumber":
        $(".co-itemnumber, .co-ordernumber").hide()
        $(".co-itemnumber").show()
        break;

      case "co-ordernumber":
        $(".co-itemnumber, .co-ordernumber").hide()
        $(".co-ordernumber").show()
        break

      default:
        $(".co-itemnumber, .co-ordernumber").hide()
        break
    }
  })


  function selectColor() {

    // 現在選択されてる項目によって色設定
    if($('select').find('option:selected').hasClass('not-select')) {
      $('select').css({'color': '#b9c5ce'})
    }

  　 // 項目が変更された時、条件によって色変更
    $('select').on('change', function(){
      if($(this).find('option:selected').hasClass('not-select')) {
        $(this).css({'color': '#b9c5ce'})
      } else {
        $(this).css({'color': '#231916'})
      }
    })
  }

  selectColor()

  //画像の縦横フィット
  /*
  * width: auto;
  * height: auto;
  * max-width: 100%;
  * max-height: 100%;
  * がIE11では効かない
  */
  function imgwh(target){
    $(target).each(function(){
      let imgw = $(this).width()
      let imgh = $(this).height()
      if(imgw <= imgh){
        $(this).addClass("himg")
      }else{
        $(this).addClass("wimg")
      }
    })
  }

  //アーティスト詳細ページ
  //imgwh(".artists_details_img img")

  //商品詳細ページ
  //imgwh(".lightcase_trigger img")
  //商品詳細ページサームネイル
  //imgwh(".details_slide_sub_item img")
  //imgwh(".modal_main img")

  //一部のポイントを利用するが選択された場合はinputのdisabledを削除
  $(".pay_tpoint_list input[type=radio]").on("change", function(){
    const $pay_tpoint_flag = $(".pay_tpoint_list input[type=radio]:checked").attr("data-pay_tpoint")

    if($pay_tpoint_flag == 1){
      $(".pay_tpoint_input").removeAttr("disabled")
    }else{
      $(".pay_tpoint_input").attr("disabled", "disabled")
    }

  })
})




document.addEventListener("DOMContentLoaded", () => {
  function truncateText(selector, maxLength, ellipsis) {
    const elements = document.querySelectorAll(selector); // 指定されたセレクタの要素を取得

    elements.forEach((element) => {
      const originalText = element.textContent; // 元のテキストを取得
      if (originalText.length > maxLength) {
        const truncatedText = originalText.slice(0, maxLength) + ellipsis; // 指定された文字数に切り取り、省略語を追加
        element.textContent = truncatedText; // テキストを更新
      }
    });
  }

  // 使用例
  truncateText(".short", 15, "...");
});